import React, {useState, useEffect,useRef } from 'react'
import Table from 'react-bootstrap/Table';
import  * as resumeUpdateApi from './../../api/resumeUpdateApi';
import { useSignalAbort } from '../../api/useSignalAbort';
import { BsEyeFill } from "react-icons/bs";
import { MdFilterList } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import Modal from 'react-bootstrap/Modal'; 
import { Spinner } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { Button, ModalBody, ModalTitle } from 'react-bootstrap';
import * as resumeDropApi from './../../api/resumeDropApi';
// import Datetime from 'react-bootstrap-datetimepicker';
// import 'react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleApiErrors } from "../../api/handleApiErrors";
import { convertDateForDisplay,convertDateForApi, dateFormat } from "../../HelperFile";
import Form from 'react-bootstrap/Form';
import { FcSearch } from "react-icons/fc";
import { Dropdown } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { IoIosClose } from 'react-icons/io'; 


function ResumeUpdate() {
  const abortConstants = useSignalAbort()
  const [resumeFields, setResumefields] = useState([])
  const [showModal, setShowModal] = useState(false); 
  const [selectedRowIndex, setSelectedRowIndex] = useState(null); 

  const [cvreviewer,setCvreviewer] = useState()
  const [cvreviewerSelect,setCvreviewerSelect] = useState()
  const [billingStatus,setBillingStatus] = useState()
  const [billingStatusSelect,setBillingStatusSelect] = useState()

  const [isLoading, setIsLoading] = useState(false);
  const [showReadOnlyModal, setShowReadOnlyModal] = useState(false);

  const [career,setCareer] = useState()
  const [carrerselect,SetCareerSelect] = useState()
  const [reviewedDate, setReviewedDate] = useState('2024-03-4');
  const [validated, setValidated] = useState(false);

     const [searchQuery, setSearchQuery] = useState('');
   const [filteredFields, setFilteredFields] = useState([]);
  const [formData, setFormData] = useState({
    // // Define state for form fields
    // FullName: '',
    // Gender:'',
    // DateofBirth:'',
    // MobileNo: '',
    // EmailId:'',
    // Certification: '',
    // CurrentJobTitle:'',
    // CountryName:'',
    // EmploymentStatus:'',
    // MaritalStatus:'',
    // ReleventExperience:'',
    // StateName:'',
    // CurrentEmployer:'',
    // CurrentSalary:'',
    // ExpectedSalary:'',
    // QualificationsName:'',
    // SourcesName:''
  });

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleFilterIconClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleStartDateChange = date => {
    setStartDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };


  let InitialFeedback = ''; // Example initialization
let Client = '';  
let OutCome = ''; 
let EmployeeDocs = '';  
let BilledAmount = 0;
 let PostRecruitFeeback = '';  
 let CVSource='';
 let ClientContactNumber='';
let LinkedIn = ''; 
let AreaofExpertise = '';  
let RefSource = '';
 let ClientContactEmail = '';  
let ClientWebsite = ''; 
let ContactPersonName='';
let ReviewedDate="2024-02-23";

// const handleDateChange = (newDate) => {
//   setReviewedDate(newDate);
//   console.log(newDate);
// };

// Function to format the date as "YYYY-MM-DD"
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding leading zero if needed
  const day = date.getDate().toString().padStart(2, '0'); // Adding leading zero if needed
  return `${year}-${month}-${day}`;
};


const handleSearch = (event) => {
  const query = event.target.value.toLowerCase();
  setSearchQuery(query);

  // Perform filtering logic here based on the search query
  const filtered = resumeFields.filter(fields =>
    Object.values(fields).some(value =>
      typeof value === 'string' && value.toLowerCase().includes(query)
    )
  );
  setFilteredFields(filtered);
};

// Use filteredFields if searchQuery is not empty, otherwise use resumeFields
const fieldsToDisplay = searchQuery ? filteredFields : resumeFields;

const handleDateChange = (e) => {
  // const newDate = new Date();
  setReviewedDate(e.target.value);
  console.log(e.target.value);
};


  useEffect(() => {
    getAllData(abortConstants.controllerConfig)
  },[])

  const getAllData = (abortToken) =>{
    getResume(startDate,endDate,abortToken)
    getCvreviewer(abortToken)
    getBilling(abortToken)
  }

//get resume fields api call
const getResume = async (frmDate,toDate,abortToken) => {
  setIsLoading(true);
  const startDate = convertDateForApi(frmDate)
  console.log(startDate);
const endDate=convertDateForApi(toDate)
console.log(endDate);



  try{
    const result = await resumeUpdateApi.getResume(startDate,endDate,abortToken)

    if(result){
      setIsLoading(false);
    }

  setResumefields(result.data.Profile)
    console.log(result.data.Profile);
  }
  catch(error){
    console.log(error);
    handleApiErrors(error, 'ResumeUpdate', 'resumeUpdate_response', 'resumeUpdate_timeout', 'resumeUpdate_request', setIsLoading);
    setIsLoading(false);

  }finally {
    setIsLoading(false);
  }
}


//update resume api call
const updateResume = async (id,data,abortToken) => {
       console.log("edit",id,data);
       try{
        const result = await resumeUpdateApi.updateResume(id,data,abortToken)
           
        if(result){
          setIsLoading(false);
        }

        toast.success(result.data.message,{
          autoClose:5000,
        })
        console.log(result);
      }
      catch(error){
        console.log(error);
        toast.error(error)
        handleApiErrors(error, 'ResumeUpdate', 'resumeUpdate_response', 'resumeUpdate_timeout', 'resumeUpdate_request', setIsLoading);
        setIsLoading(false);
      }
}

const renderLoading = (item) => {
  if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`]) {
    return true;
  } else {
    return false;
  }
}


//handle edit form submit
const handleEditSubmit = async (e) => {
  // e.preventDefault();
  setIsLoading(true);
  e.preventDefault(); // Prevent default form submission

  const form = e.currentTarget; // Get the form element
  if (form.checkValidity() === false) {
    e.stopPropagation(); // Stop event propagation if the form is invalid
    setValidated(true); // Update validated state to show validation feedback
    setIsLoading(false);
    return; // Exit the function if the form is invalid
  }


 
console.log(reviewedDate);
  
  const formattedDate = convertDateForApi(formData.CreatedDate)
  let newData = {
       ...formData,
       ReviewedBy:Number(cvreviewerSelect),
       BilledStatusId:Number(billingStatusSelect),
CareerLevel:carrerselect,
InitialFeedback:formData.InitialFeedback,
Client:formData.Client,
OutCome:formData.OutCome,
EmployeeDocs:formData.EmployeeDocs,
BilledAmount:Number(formData.BilledAmount),
PostRecruitFeeback:formData.PostRecruitFeeback,
CVSource:formData.CVSource,
ClientContactNumber:formData.ClientContactNumber,
LinkedIn:formData.LinkedIn,
AreaofExpertise:formData.AreaofExpertise,
RefSource:formData.RefSource,
ClientContactEmail:formData.ClientContactEmail,
ClientWebsite:formData.ClientWebsite,
ContactPersonName:formData.ContactPersonName,
ReviewedDate: reviewedDate ,// Set ReviewedDate to the current date
CreatedDate:formattedDate
}
  console.log(newData);

  try{
    await updateResume(selectedRowIndex,newData,abortConstants.controllerConfig)

    // If successful, update local state (resumeFields) with the edited data
    const updatedResumeFields = resumeFields.map((fields, index) =>
      index === selectedRowIndex ? newData : fields
    );
    setResumefields(updatedResumeFields);

    console.log("update",updatedResumeFields);

    // Close the edit modal
    toggleModal();
     
  }
  catch(error){
     console.log(error);
  }

}


//get cv reviewer api call
const getCvreviewer = async (abortToken)=>{
  try{
    const result= await resumeDropApi.getCvreviewer(abortToken)
    setCvreviewer(result?.data?.User);
    setCvreviewerSelect(result?.data?.User[0]?.userid)
console.log(result?.data?.User);
   
  }
  catch(error){
   console.log(error);
  }
}
const handlecvReviewerselect = (e) => {
  setCvreviewerSelect(e.target.value);
  console.log(cvreviewerSelect);
}

const handlecareerselect = (e) =>{
  SetCareerSelect(e.target.value);
  console.log(carrerselect);
}


//get billing status api call
const getBilling = async (abortToken)=>{
  try{
    const result= await resumeDropApi.getBilling(abortToken)
    setBillingStatus(result?.data?. BillingStatus);
    setBillingStatusSelect(result?.data?.BillingStatus[0]?.Id)
console.log(result?.data?.BillingStatus );
   
  }
  catch(error){
   console.log(error);
  }
}
const handleBillingStatusSelect = (e) => {
  setBillingStatusSelect(e.target.value);
  console.log(billingStatusSelect);
}


// Function to toggle modal visibility
const toggleModal = (index) => {
  console.log(resumeFields[index]);

  const profile_id = resumeFields[index]?.ProfileId
  setSelectedRowIndex(profile_id);


 if (!showModal) {
  const formatedDate = (resumeFields[index].ReviewedDate).split(" ")[0]

  console.log(formatedDate);

    setFormData(resumeFields[index]);

console.log(reviewedDate);

    setReviewedDate(formatedDate)
    console.log(resumeFields[index].ReviewedDate);

  }
  setShowModal(!showModal);
  console.log(resumeFields[index]);
};



// Function to handle form field changes
const handleInputChange = (e) => {
  const { name, value } = e.target;
  console.log(name,value);
  setFormData({
    ...formData,
    [name]: value
  });
};

 // Function to toggle read-only modal visibility
 const toggleReadOnlyModal = (index) => {
  setShowReadOnlyModal(!showReadOnlyModal);
  setSelectedRowIndex(index);
};

// Function to handle form submission
const handleSubmit = (e) => {
  e.preventDefault();
  // Your form submission logic here
};

  const csvHeaders = [
      "Full Name",
      "Gender",
      "Date of Birth",
      "Mobile No",
      "Reviewed By",
      "Current Job Title",
      "Country Name",
      "Employment Status",
      "Created Date",
      "Status"
  ];

  return (

<div style={{width: '100%',margin :'10px'}}>
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
       <h2 style={{ fontSize: '1.5rem', marginBottom: '0' ,marginLeft:'25px'}}>Resume Details</h2>
       


 {/* Icon placed above the table */}
 <div style={{ textAlign: 'end', marginBottom: '10px' }}>

 <FcSearch style={{ marginRight: '5px', color: '#888' }} />
 <input
        type="text"
       placeholder="Search..."
       style={{ marginRight: '65px', padding: '5px', border: 'none', borderBottom: '1px solid #172446', outline: 'none' }}
        value={searchQuery}     
        onChange={handleSearch}
       />

  <MdFilterList className="filter-icon-button" onClick={handleFilterIconClick} size={20} style={{ marginRight: '40px', color: '#172446' }} />
      <Dropdown.Menu 
        ref={dropdownRef}
        show={showDropdown}
        style={{ position: 'absolute', top: 100, right: 24, zIndex: 999 }}
      >

{/* Close Icon */}
<div style={{ textAlign: 'right', paddingRight: '10px', cursor: 'pointer' }} onClick={() => setShowDropdown(false)}>
        <IoIosClose size={24} />
    </div>

        <h5 style={{  textAlign:'center',color:'#172446'}}>Created Between:</h5>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
    <div className="datepicker-with-icon" style={{ marginRight: '10px' }}>
      <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        dateFormat = {dateFormat()}
        placeholderText="dd-MM-yyyy"
      />
    </div>  
    <div style={{ margin: '0 10px' }}>-</div>

    <div className="datepicker-with-icon">
      <DatePicker
        selected={endDate}
        onChange={handleEndDateChange}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        dateFormat = {dateFormat()}
        placeholderText="dd-MM-yyyy"
      />
    </div>
  </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '10px' }}  >
    <Button   
    style={{backgroundColor:'#172446',color:'#FFFFFF',border:'none'}}  
    onClick={() => {
      setShowDropdown(false); // Close the dropdown
      getResume(startDate, endDate, abortConstants.controllerConfig);
    }}  
    >
    {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              Searching...
            </>
          ) : (
          
               
              'Search'
            
          )}
    </Button>
  </div>
        
      </Dropdown.Menu>

                

     <CSVLink data={[csvHeaders, ...fieldsToDisplay.map(fields => [
                   fields.FullName,
                   fields.Gender === 'F' ? 'Female' : fields.Gender === 'M' ? 'Male' : fields.Gender,
                   fields.DateofBirth,
                   fields.MobileNo,
                   fields.CVReveiwer,
                   fields.CurrentJobTitle,
                   fields.CountryName,
                   fields.EmploymentStatus,
                   fields.CreatedDate ,  
                   fields.Status === 0 ? 'Pending' : 'Reviewed'

                  ])]} filename={"resumeFields.csv"}>
                       <BiExport size={20} style={{ marginRight: '10px', color: '#172446'}} />
    </CSVLink>

             </div> 
             </div>


    <div style={{ margin :'20px' ,height:'590px', overflowX: 'auto' }}>



             {renderLoading("resumeUpdate") || resumeFields===null? (
              <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
              {resumeFields === null ? "No data" : <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />}
            </div>
             ):(
              <Table striped bordered hover style={{ minWidth: '1000px',marginTop:'10px' }}>
              <thead>
                <tr>
                <th style={{ position: 'sticky', top: -1}}>Job Code</th>
                   <th style={{ position: 'sticky', top: -1}}>Full Name</th>
                  <th style={{ position: 'sticky', top: -1}}>Gender</th>
                   <th style={{ position: 'sticky', top: -1}}>Date of Birth</th>
                   <th style={{ position: 'sticky', top: -1}}>Mobile No</th>
                  <th style={{ position: 'sticky', top: -1}}>Reviewed By</th>
                   <th style={{ position: 'sticky', top: -1}}>Current Job Title</th>
                  <th style={{ position: 'sticky', top: -1}}>Country Name</th>
                   <th style={{ position: 'sticky', top: -1}}>Employment Status</th>
                   <th style={{ position: 'sticky', top: -1}}>Created Date</th>
                   <th style={{ position: 'sticky', top: -1}}>Status</th>
                   <th style={{ position: 'sticky', top: -1}}>Actions</th>
                </tr>
              </thead>
              <tbody>
              {fieldsToDisplay?.map((fields, index) => (
                    <tr key={index}>
                   <td>{fields.JobCode}</td>
                      <td>{fields.FullName}</td>
                      <td>{fields.Gender === 'F' ? 'Female' : fields.Gender === 'M' ? 'Male' : fields.Gender}</td>
                       <td>{convertDateForDisplay(fields.DateofBirth)}</td>
                      <td>{fields.MobileNo}</td>
                      <td>{fields.CVReveiwer}</td>
                       <td>{fields.CurrentJobTitle}</td>
                      <td>{fields.CountryName}</td>
                      <td>{fields.EmploymentStatus}</td>
                      <td>{convertDateForDisplay(fields.CreatedDate)}</td>
                      {/* <td>{fields.CreatedDate}</td> */}
                      <td>{fields.Status === 0 ? 'Pending' : 'Reviewed'}</td> 
                      <td >
                        <AiFillEdit onClick={() => toggleModal(index)} style={{ cursor: 'pointer' }} />
                        <BsEyeFill onClick={() => toggleReadOnlyModal(index)}style={{marginLeft:'20px'}}/>
                        </td>
                      
                    </tr>
                  ))}
              </tbody>
            </Table>
             )}

   
 <Modal show={showReadOnlyModal} onHide={() => setShowReadOnlyModal(false)} size="xl" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>General Information </Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <div className="row">
      <div className="col-md-2 mb-3">
        <label htmlFor="FullName" className="form-label" style={{ fontWeight: 'bold' }}>Full Name:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.FullName} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="Gender" className="form-label" style={{ fontWeight: 'bold' }}>Gender:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.Gender} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="DateofBirth" className="form-label" style={{ fontWeight: 'bold' }}>Date of Birth:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.DateofBirth} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="MobileNo" className="form-label" style={{ fontWeight: 'bold' }}>Mobile No:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.MobileNo} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="EmailId" className="form-label" style={{ fontWeight: 'bold' }}>Email Id:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.EmailId} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="Certification" className="form-label" style={{ fontWeight: 'bold' }}>Certification:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.Certification} readOnly />
      </div>
     </div>


     <div className="row">
       
      <div className="col-md-2 mb-3">
        <label htmlFor="CurrentJobTitle" className="form-label" style={{ fontWeight: 'bold' }}>Current Job Title:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CurrentJobTitle} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="CountryName" className="form-label" style={{ fontWeight: 'bold' }}>Country Name:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CountryName} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="EmploymentStatus" className="form-label" style={{ fontWeight: 'bold' }}>Employment Status:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.EmploymentStatus} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="EmploymentStatus" className="form-label" style={{ fontWeight: 'bold' }}>Marital Status:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.EmploymentStatus} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="ReleventExperience" className="form-label" style={{ fontWeight: 'bold' }}>Relevent Experience:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ReleventExperience} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="StateName" className="form-label" style={{ fontWeight: 'bold' }}>State Name:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.StateName} readOnly />
      </div>

     </div>

     <div className="row">
       
      <div className="col-md-2 mb-3">
        <label htmlFor="CurrentEmployer" className="form-label" style={{ fontWeight: 'bold' }}>CurrentEmployer:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CurrentEmployer} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="CurrentSalary" className="form-label" style={{ fontWeight: 'bold' }}>Current Salary:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CurrentSalary} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="ExpectedSalary" className="form-label" style={{ fontWeight: 'bold' }}>Expected Salary:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ExpectedSalary} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="QualificationsName" className="form-label" style={{ fontWeight: 'bold' }}>Qualifications Name:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.QualificationsName} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="SourcesName" className="form-label" style={{ fontWeight: 'bold' }}>Sources Name:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.SourcesName} readOnly />
      </div>
      <div className="col-md-2 mb-3">
        <label htmlFor="CreatedDate" className="form-label" style={{ fontWeight: 'bold' }}>Created Date:</label>
        <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CreatedDate} readOnly />
      </div>

     </div>

   <div className="row">
       
       <div className="col-md-2 mb-3">
         <label htmlFor="InitialFeedback" className="form-label" style={{ fontWeight: 'bold' }}>Initial Feedback:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.InitialFeedback} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="Client" className="form-label" style={{ fontWeight: 'bold' }}>Client:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.Client} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="OutCome" className="form-label" style={{ fontWeight: 'bold' }}>OutCome:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.OutCome} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="EmployeeDocs" className="form-label" style={{ fontWeight: 'bold' }}>Employee Docs:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.EmployeeDocs} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="BilledAmount" className="form-label" style={{ fontWeight: 'bold' }}>Billed Amount:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.BilledAmount} readOnly />
       </div>
        
 
      </div>
 
      <div className="row">
       
       <div className="col-md-2 mb-3">
         <label htmlFor="PostRecruitFeeback" className="form-label" style={{ fontWeight: 'bold' }}>PostRecruit Feeback:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.PostRecruitFeeback} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="CVSource" className="form-label" style={{ fontWeight: 'bold' }}>CV Source:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.CVSource} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="ClientContactNumber" className="form-label" style={{ fontWeight: 'bold' }}>Client Contact Number:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ClientContactNumber} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="LinkedIn" className="form-label" style={{ fontWeight: 'bold' }}>LinkedIn:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.LinkedIn} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="AreaofExpertise" className="form-label" style={{ fontWeight: 'bold' }}>Area of Expertise:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.AreaofExpertise} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="RefSource" className="form-label" style={{ fontWeight: 'bold' }}>Ref Source:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.RefSource} readOnly />
       </div>
 
      </div>


      <div className="row">
       
       <div className="col-md-2 mb-3">
         <label htmlFor="ClientContactEmail" className="form-label" style={{ fontWeight: 'bold' }}>Client Contact Email:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ClientContactEmail} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="ClientWebsite" className="form-label" style={{ fontWeight: 'bold' }}>Client Website:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ClientWebsite} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="ContactPersonName" className="form-label" style={{ fontWeight: 'bold' }}>Contact Person Name:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ContactPersonName} readOnly />
       </div>
       <div className="col-md-2 mb-3">
         <label htmlFor="ReviewedDate" className="form-label" style={{ fontWeight: 'bold' }}>Reviewed Date:</label>
         <input type="text" className="form-control" value={resumeFields[selectedRowIndex]?.ReviewedDate} readOnly />
       </div>
        
 
      </div>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReadOnlyModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal> 
  



 <Modal show={showModal} onHide={toggleModal}  size="xl" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>General Information</Modal.Title>
        </Modal.Header>
<Form onSubmit={handleEditSubmit} noValidate validated={validated}>

        {/* 1st section */}
        <Modal.Body>

          {/* 1st row */}
          <div className="row">
     <div className="col-md-2 mb-3">
      
      <label htmlFor="FullName" style={{ fontWeight: 'bold' }}>Full Name:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="FullName"
         value={formData.FullName}
         style={{ background: 'none', borderColor: '#cccccc' }}
         
      />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="Gender" style={{ fontWeight: 'bold' }}>Gender:</label>
      <input
    type="text"
    className="form-control mt-2"
    id="Gender"
    value={formData.Gender === 'F' ? 'Female' : formData.Gender === 'M' ? 'Male' : formData.Gender}
     style={{ background: 'none', borderColor: '#cccccc' }}
  />
    </div>
    <div className="col-md-2 mb-3 ">
      <label htmlFor="DateofBirth" style={{ fontWeight: 'bold' }}>Date of Birth:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="DateofBirth"
         value={formData.DateofBirth}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="MobileNo" style={{ fontWeight: 'bold' }}>Mobile No:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="MobileNo"
         value={formData.MobileNo}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="EmailId" style={{ fontWeight: 'bold' }}>Email Id:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="EmailId"
         value={formData.EmailId}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    <div className="col-md-2 mb-3 ">
      <label htmlFor="Certification" style={{ fontWeight: 'bold' }}>Certification:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="Certification"
         value={formData.Certification}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
     
</div>
    {/* 1st row end */}


{/* 2nd row */}
  <div className="row">
       

    <div className="col-md-2 mb-3">
      <label htmlFor="CurrentJobTitle" style={{ fontWeight: 'bold' }}>Current Job Title:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="CurrentJobTitle"
         value={formData.CurrentJobTitle}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="CountryName" style={{ fontWeight: 'bold' }}>Country Name:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="CountryName"
         value={formData.CountryName}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="EmploymentStatus" style={{ fontWeight: 'bold' }}>Employment Status:</label>
      <input
      
        type="text"
        className="form-control mt-2"
        id="EmploymentStatus"
         value={formData.EmploymentStatus}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="MaritalStatus" style={{ fontWeight: 'bold' }}>Marital Status:</label>
      <input
    type="text"
    className="form-control mt-2"
    id="MaritalStatus"
    value={formData.MaritalStatus === 'S' ? 'Single' : formData.MaritalStatus === 'M' ? 'Married' : formData.MaritalStatus === 'U' ? 'Unmarried' : formData.MaritalStatus}
     style={{ background: 'none', borderColor: '#cccccc' }}
  />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="ReleventExperience" style={{ fontWeight: 'bold' }}>Relevent Experience:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="ReleventExperience"
         value={formData.ReleventExperience}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="StateName" style={{ fontWeight: 'bold' }}>Emirate Name:</label>
      <input
      
        type="text"
        className="form-control mt-2"
        id="StateName"
         value={formData.StateName}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    
    
   </div>
{/* 2nd row end*/}


{/* 3rd row */}
 <div className="row">
 <div className="col-md-2 mb-3">
      <label htmlFor="CurrentEmployer" style={{ fontWeight: 'bold' }}>Current Employer:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="CurrentEmployer"
         value={formData.CurrentEmployer}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="CurrentSalary" style={{ fontWeight: 'bold' }}>Current Salary:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="CurrentSalary"
         value={formData.CurrentSalary}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    <div className="col-md-2 mb-3">
      <label htmlFor="ExpectedSalary" style={{ fontWeight: 'bold' }}>Expected Salary:</label>
      <input
      
        type="text"
        className="form-control mt-2"
        id="ExpectedSalary"
         value={formData.ExpectedSalary}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="QualificationsName" style={{ fontWeight: 'bold' }}>Qualifications Name:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="QualificationsName"
         value={formData.QualificationsName}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
    
    <div className="col-md-2 mb-3">
      <label htmlFor="SourcesName" style={{ fontWeight: 'bold' }}>Sources Name:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="SourcesName"
         value={formData.SourcesName}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>

    <div className="col-md-2 mb-3">
      <label htmlFor="CreatedDate" style={{ fontWeight: 'bold' }}>Created Date:</label>
      <input
        type="text"
        className="form-control mt-2"
        id="CreatedDate"
         value={convertDateForDisplay(formData.CreatedDate)}
         style={{ background: 'none', borderColor: '#cccccc' }}
      />
    </div>
     
</div>
{/* 3rd row end */}

 </Modal.Body>
{/* 1st section  end*/}

<hr />

{/* 2nd section */}
<Modal.Title  style={{ marginLeft: '20px' }}>Review</Modal.Title>
<Modal.Body>

{/* 1st row */}
<div className="row">

<div className="col-md-3 mb-3">
<label htmlFor="CareerLevel" style={{ fontWeight: 'bold' }}>Carrer Level:</label>
  <select
    className="form-control mt-2"
    // id="CareerLevel"
    required 
    value={carrerselect} onChange={handlecareerselect}
  >
    <option value="0-6 Months: Entry Level">0-6 Months: Entry Level</option>
    <option value="1-2 Years: Early Carrer">1-2 Years: Early Carrer</option>
    <option value="5-10 Years: Mid-Level">5-10 Years: Mid-Level</option>
    <option value="10-20 Years: Senior Level">10-20 Years: Senior Level</option>
    <option value="20+ Years: Executive Carrer">20+ Years: Executive Carrer</option>
   </select>
</div>

<div className="col-md-3 mb-3">
  <label htmlFor="CVReveiwer" style={{ fontWeight: 'bold' }}>CV Reviewer:</label>
  <select
    className="form-control mt-2"
    // id="CVReveiwer"
     required 
    name='firstname' value={cvreviewerSelect} onChange={handlecvReviewerselect}
  >
{cvreviewer?.map((item)=>
<option key={item.firstname} name={item.firstname} value={item.userid}>{item.firstname}</option>
)}

    
  </select>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="initialFeedback">
    <Form.Label style={{ fontWeight: 'bold' }}>Initial Feedback:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      name='InitialFeedback'
      value={formData.InitialFeedback}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.InitialFeedback}
    />
    <Form.Control.Feedback type="invalid">
      Please provide initial feedback.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="client">
    <Form.Label style={{ fontWeight: 'bold' }}>Client:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      name='Client'
      value={formData.Client}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.Client}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a client name.
    </Form.Control.Feedback>
  </Form.Group>
</div>

</div>
{/* 1st row end */}

{/* 2nd row  */}
<div className="row">

<div className="col-md-3 mb-3">
<Form.Group controlId="outcome">
    <Form.Label style={{ fontWeight: 'bold' }}>Outcome:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      name='OutCome'
      value={formData.OutCome}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.OutCome}
    />
    <Form.Control.Feedback type="invalid">
      Please provide an outcome.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="employeeDocs">
    <Form.Label style={{ fontWeight: 'bold' }}>Employee Docs:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      name='EmployeeDocs'
      value={formData.EmployeeDocs}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.EmployeeDocs}
    />
    <Form.Control.Feedback type="invalid">
      Please provide employee documents.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<label htmlFor="BilledAmount" style={{ fontWeight: 'bold' }}>Billed Amount:</label>
  <input
    type="text"
    className="form-control mt-2"
    id="BilledAmount"  name='BilledAmount'
    value={formData.BilledAmount}
    onChange={handleInputChange}
    required 
  />
</div>

<div className="col-md-3 mb-3">
  <label htmlFor="Billedstatus" style={{ fontWeight: 'bold' }}>Billing Status:</label>
  <select
    className="form-control mt-2"
    // id="Billedstatus"
    required 
    name='Name' value={billingStatusSelect} onChange={handleBillingStatusSelect}
  >
    {billingStatus?.map((item)=>
<option key={item.Name} name={item.Name} value={item.Id}>{item.Name}</option>
)}
  </select>
</div>

</div>
{/* 2rd row end */}

{/* 3rd row  */}
<div className="row">

<div className="col-md-3 mb-3">
<Form.Group controlId="postRecruitFeedback">
    <Form.Label style={{ fontWeight: 'bold' }}>Post Recruit Feedback:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="PostRecruitFeeback"
      name='PostRecruitFeeback'
      value={formData.PostRecruitFeeback}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.PostRecruitFeeback}
    />
    <Form.Control.Feedback type="invalid">
      Please provide post recruit feedback.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="cvSource">
    <Form.Label style={{ fontWeight: 'bold' }}>CV Source:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="CVSource"
      name='CVSource'
      value={formData.CVSource}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.CVSource}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a CV source.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="clientContactNumber">
    <Form.Label style={{ fontWeight: 'bold' }}>Client Contact Number:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="ClientContactNumber"
      name='ClientContactNumber'
      value={formData.ClientContactNumber}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.ClientContactNumber}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a valid client contact number.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="linkedIn">
    <Form.Label style={{ fontWeight: 'bold' }}>Linked In:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="LinkedIn"
      name='LinkedIn'
      value={formData.LinkedIn}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.LinkedIn}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a valid LinkedIn profile.
    </Form.Control.Feedback>
  </Form.Group>
</div>

</div>
{/* 3rd row end */}

{/* 4th row  */}
<div className="row">

<div className="col-md-3 mb-3">
<Form.Group controlId="areaOfExpertise">
    <Form.Label style={{ fontWeight: 'bold' }}>Area of Expertise:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="AreaofExpertise"
      name='AreaofExpertise'
      value={formData.AreaofExpertise}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.AreaofExpertise}
    />
    <Form.Control.Feedback type="invalid">
      Please provide the area of expertise.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="referralSource">
    <Form.Label style={{ fontWeight: 'bold' }}>Referral Source:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="RefSource"
      name='RefSource'
      value={formData.RefSource}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.RefSource}
    />
    <Form.Control.Feedback type="invalid">
      Please provide the referral source.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="clientContactEmail">
    <Form.Label style={{ fontWeight: 'bold' }}>Client Contact Email:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="ClientContactEmail"
      name='ClientContactEmail'
      value={formData.ClientContactEmail}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.ClientContactEmail}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a valid client contact email.
    </Form.Control.Feedback>
  </Form.Group>
</div>

<div className="col-md-3 mb-3">
<Form.Group controlId="clientWebsite">
    <Form.Label style={{ fontWeight: 'bold' }}>Client Website:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="ClientWebsite"
      name='ClientWebsite'
      value={formData.ClientWebsite}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.ClientWebsite}
    />
    <Form.Control.Feedback type="invalid">
      Please provide a valid client website.
    </Form.Control.Feedback>
  </Form.Group>
</div>

</div>
{/* 4th row end */}

{/* 5th row  */}
<div className="row">

<div className="col-md-3 mb-3">
<Form.Group controlId="contactPersonName">
    <Form.Label style={{ fontWeight: 'bold' }}>Contact Person's Name:</Form.Label>
    <Form.Control
      type="text"
      className="form-control mt-2"
      // id="ContactPersonName"
      name='ContactPersonName'
      value={formData.ContactPersonName}
      onChange={handleInputChange}
      required 
      isInvalid={validated && !formData.ContactPersonName}
    />
    <Form.Control.Feedback type="invalid">
      Please provide the contact person's name.
    </Form.Control.Feedback>
  </Form.Group>
</div>
 
<div className="col-md-3 mb-3">
<Form.Group controlId="reviewedDate">
    <Form.Label style={{ fontWeight: 'bold' }}>Reviewed Date:</Form.Label>
    <Form.Control
      type="date"
      className="form-control mt-2"
      // id="ReviewedDate"
      value={reviewedDate}
      onChange={handleDateChange}
      isInvalid={validated && !reviewedDate}
 
    />
    <Form.Control.Feedback type="invalid">
      Please provide a reviewed date.
    </Form.Control.Feedback>
  </Form.Group>
</div>

 

</div>
{/* 5th row end */}
<div style={{ textAlign: 'center' }}>
  <Button type="submit" style={{ fontWeight:'bold', color:'white', backgroundColor:'#172446', width:'25%', border:'none' }}> 
  
  {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Submitting...
            </>
          ) : (
         'Submit'
    )}
  
  
  </Button>
</div>

</Modal.Body>

</Form>
{/* 2nd section end */}

      </Modal>


  </div></div>
      )
}

export default ResumeUpdate